<template>
    <div v-if="shows" class="d-flex justify-center align-center fill-height" :class="{ disabled }">
        <v-checkbox v-if="shows" v-model="isSelected" v-bind="{ readonly, disabled }" class="d-inline-block my-0 py-0 mr-n8" color="primary" hide-details @change="emit" />
    </div>
</template>

<script>
import { initExpoEmployer, initExpoMatching } from "@/assets/variables/inits";

export default {
    props: {
        mode: { type: String, default: "form" },
        value: { type: Object, default: initExpoMatching }, // form
        employer: { type: Object, default: initExpoEmployer },
        matchings: { type: Array, default: () => [] },

        date: { type: String, default: null },
        time: { type: Number, default: 8 },
    },
    data: () => ({
        form: initExpoMatching(),

        isSelected: false,
    }),
    computed: {
        readonly() {
            if (this.mode == "read") return true;
            return !!this.item && this.item._id != this.value._id && this.item._employer != this.employer._id;
        },
        datetime() {
            return this.$dayjs(this.date).set("hour", this.time);
        },
        shows() {
            return this.employer.interview.schedules.some((item) => this.datetime.isSame(item));
        },
        item() {
            return this.matchings.find((item) => this.datetime.isSame(item.interviewAt));
        },
        disabled() {
            return !!this.item && this.item._id != this.value._id && this.item._employer == this.employer._id;
        },
    },
    methods: {
        sync() {
            this.form = initExpoMatching(this.value);
            this.isSelected = this.datetime.isSame(this.form.interviewAt);
        },
        emit() {
            if (this.isSelected) {
                this.form.interviewAt = this.datetime.toISOString();
            } else {
                this.form.interviewAt = null;
            }

            this.$emit("input", this.form);
        },
    },
    watch: {
        value() {
            this.sync();
        },
    },
    mounted() {
        this.sync();
    },
};
</script>

<style lang="scss" scoped>
::v-deep .mdi-checkbox-blank-outline {
    &,
    &::before {
        color: #999 !important;
    }
}

.disabled {
    background: #aaa;

    ::v-deep .mdi-checkbox-blank-outline {
        &,
        &::before {
            color: #666 !important;
        }
    }
}
</style>